import { useQuery } from '@hooks/reactQuery';

import { getConfigurationTemplateModelCollections } from '@api/configurationTemplates';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES_MODEL_COLLECTIONS } from '@constants/queryKeys';

interface IUseQueryConfigurationTemplatesModelCollections {
	configurationTemplateModelCollections: TSelectOption<string>[];
	isLoadingConfigurationTemplateModelCollections: boolean;
}

const useQueryConfigurationTemplatesModelCollections = (): IUseQueryConfigurationTemplatesModelCollections => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONFIGURATION_TEMPLATES_MODEL_COLLECTIONS],
		queryFn: getConfigurationTemplateModelCollections,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'id',
			labelKey: 'name',
		}),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		configurationTemplateModelCollections: data || [],
		isLoadingConfigurationTemplateModelCollections: (!!data && isLoading) || isFetching,
	};
};

export default useQueryConfigurationTemplatesModelCollections;
